import type { BulkTags } from '../types'

export function compareTags(bulkValue: BulkTags, orderValue: string[]): BulkTags {
  const commonValues = bulkValue.value.filter(value => orderValue.includes(value))

  return {
    value: commonValues,
    hasAlsoMixedValues:
      bulkValue.hasAlsoMixedValues ||
      bulkValue.value.length !== commonValues.length ||
      orderValue.length !== commonValues.length,
  }
}
